import { assertNull } from "common/assert";
import { cancel, delayAnimation } from "common/promises";
import { Sheets } from "common/sheets";
import * as R from "ramda";
// 53 ~ 56: 0~3
// 53 ~ 62: 0~9
// 63 ~ 66: 10~13
const frameDelay = 1000 / 30;
export class Heart {
    constructor(pixiContext, sheets) {
        this.idlePlaying = null;
        this.manualPlaying = null;
        this.sprite = Sheets.animation(pixiContext, sheets, "grandpa-heart");
    }
    play() {
        this.idlePlaying = cancel.root(async (canceler) => {
            while (true) {
                await this.bounceIdle();
                canceler.check();
                if (this.manualPlaying != null) {
                    await this.manualPlaying.promise;
                }
            }
        });
    }
    async bounceIdle() {
        for (const i of R.range(0, 4)) {
            await delayAnimation(frameDelay);
            if (this.manualPlaying != null) {
                return;
            }
            this.sprite.gotoAndStop(i);
        }
    }
    dispose() {
        var _a, _b;
        (_a = this.idlePlaying) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
        (_b = this.manualPlaying) === null || _b === void 0 ? void 0 : _b.canceler.cancel();
    }
    async bounceFull(speed) {
        assertNull(this.manualPlaying, "bouncefull");
        this.manualPlaying = cancel.root(async (canceler) => {
            try {
                for (const i of R.range(0, 10)) {
                    await delayAnimation(frameDelay / speed);
                    canceler.check();
                    this.sprite.gotoAndStop(i);
                }
            }
            finally {
                this.manualPlaying = null;
            }
        });
        await this.manualPlaying.promise;
    }
    async bounceHalf() {
        assertNull(this.manualPlaying, "bounceHalf");
        this.manualPlaying = cancel.root(async (canceler) => {
            try {
                for (const i of R.range(0, 4)) {
                    await delayAnimation(frameDelay);
                    canceler.check();
                    this.sprite.gotoAndStop(i);
                }
            }
            finally {
                this.manualPlaying = null;
            }
        });
        await this.manualPlaying.promise;
    }
    async bounceHyper(speed) {
        assertNull(this.manualPlaying, "bounceHyper");
        this.manualPlaying = cancel.root(async (canceler) => {
            try {
                for (const i of R.range(10, 14)) {
                    await delayAnimation(frameDelay / speed);
                    canceler.check();
                    this.sprite.gotoAndStop(i);
                }
            }
            finally {
                this.manualPlaying = null;
            }
        });
        await this.manualPlaying.promise;
    }
}
//# sourceMappingURL=heart.js.map